import React from 'react';
import { Box, FormDialog } from '@kis-technologies/kis-ui';
import { PreviewImageOverlayProps } from '../types';

const PreviewImageOverlay = (props: PreviewImageOverlayProps) => {
  const { imageSrc, onClose } = props;

  return (
    <FormDialog
      cancelButtonAction={onClose}
      confirmButtonAction={onClose}
      confirmButtonText="Ok"
      open
      title="Preview Image"
    >
      <Box
        sx={{
          maxWidth: '620px',
          maxHeight: '320px',
          minWidth: '620px',
          minHeight: '320px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          borderRadius: '8px',
          margin: '0 auto'
        }}
      >
        <img
          src={imageSrc}
          alt="Preview"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      </Box>
    </FormDialog>
  );
};

export default PreviewImageOverlay;
